import { Link as ChakraLink, Avatar, HStack, Select } from '@chakra-ui/react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/auth';

interface IPlatformProps {
  showAvatar?: boolean;
}

export const Platform = ({ showAvatar }: IPlatformProps): JSX.Element => {
  const { pathname } = useLocation();
  const { push } = useHistory();

  const {
    user: authenticatedUser,
    venture: authenticatedVenture,
    selectVenture,
  } = useAuth();

  const onVentureChange = (ventureId: string): void => {
    const rootPath = pathname.split('/')[1];

    selectVenture(ventureId);

    push(`/${rootPath ?? 'dashboard'}`);
  };

  return (
    <HStack
      spacing={['6', '8']}
      mr={['6', '8']}
      pr={['6', '8']}
      py="1"
      borderRightWidth={1}
      borderColor="gray.700"
    >
      <Select
        id="ventureId"
        borderColor="gray.300"
        bg="gray.100"
        focusBorderColor="blue.300"
        isDisabled={!authenticatedUser.userAssignments.length}
        cursor={
          !authenticatedUser.userAssignments.length ? 'not-allowed' : 'pointer'
        }
        variant="outline"
        size="md"
        value={authenticatedVenture?.id}
        onChange={(e) => onVentureChange(e.target.value)}
      >
        {authenticatedUser.userAssignments.map((assignment) => (
          <option key={assignment.id} value={assignment.ventureId}>
            {assignment.venture?.name}
          </option>
        ))}
      </Select>

      {showAvatar && (
        <ChakraLink
          as={Link}
          to={{
            pathname: '/ventures/details',
            state: { ventureId: authenticatedVenture?.id },
          }}
        >
          <Avatar
            size="md"
            name={authenticatedVenture?.name}
            src={authenticatedVenture?.avatarUrl}
          />
        </ChakraLink>
      )}
    </HStack>
  );
};
